import React, { useCallback, useState } from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";

import {
  Grid,
  FormControl,
  NativeSelect,
  InputBase,
  Button,
} from "@material-ui/core";
import LinearProgress from "@material-ui/core/LinearProgress";
import PageviewIcon from "@material-ui/icons/Pageview";
import { useStylesApp } from "hooks/useStyles";
import { palette, useStylesGlobal } from "configurations/styles/theme";
import ClearAllIcon from "@material-ui/icons/ClearAll";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import { tipoContratacion } from "views/administración/partners/typeHiring";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
}));

const BootstrapInput = withStyles((theme) => ({
  root: {
    "label + &": {
      marginTop: theme.spacing(0),
    },
  },
  input: {
    borderRadius: 4,
    position: "relative",
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #ced4da",
    fontSize: 16,
    padding: "10px 26px 10px 12px",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:focus": {
      borderRadius: 4,
      borderColor: "#80bdff",
      boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
    },
  },
}))(InputBase);

export default function SearchCompanyAdvanced({
  update,
  setUpdate,
  setParamSearch,
}) {
  const classes = useStyles();
  const classesGlobal = useStylesGlobal();
  const [tipoPago, setTipoPago] = useState("");
  const [idempresacontadora, setIdempresacontadora] = useState("");
  const [esPartner, setEsPartner] = useState("");

  const validationInputs = () => {
    //setParamSearch("");
    let cadena = "";
    if (
      idempresacontadora.trim() === "" &&
      tipoPago.trim() === "" &&
      esPartner.trim() === ""
    ) {
      return Swal.fire({
        position: "center",
        icon: "warning",
        title: "Ingrese al menos un parámetro",
        showConfirmButton: false,
        timer: 3500,
      });
    } else {
      if (idempresacontadora.trim() !== "") {
        cadena = `${cadena}&idempresacontadora=${idempresacontadora}`;
      }
      if (tipoPago.trim() !== "") {
        cadena = `${cadena}&tipoPago=${tipoPago}`;
      }
      if (esPartner.trim() !== "") {
        cadena = `${cadena}&esPartner=${esPartner}`;
      }
    }

    //esto es con tabla paginada
    // if (update === 3 || update === 2) {
    //   setUpdate(4);
    // } else if (update === 4) {
    //   setUpdate(3);
    // }
    //limpiar buscador
    //cleanInputs();
    //llamo al afuncion de búsqueda

    setParamSearch(cadena);
    setUpdate(4);
  };

  const cleanInputs = () => {
    setIdempresacontadora("");
    setTipoPago("");
    setEsPartner("");
    setUpdate(0);
  };

  const optionsPartner = [
    {
      CODIGO: "1",
      NOMBRE: "Sí",
    },
    {
      CODIGO: "2",
      NOMBRE: "No",
    },
  ];

  return (
    <>
      <div className={classes.root}>
        <strong>Buscar por: </strong>{" "}
        <form style={{ width: "100%" }}>
          <Grid container spacing={2} justify="center" alignItems="center">
            <Grid item xs={2}>
              <label>Empresa contadora:</label>
            </Grid>
            <Grid item xs={2}>
              <input
                type="string"
                className="form-control"
                name="idempresacontadora"
                value={idempresacontadora}
                onChange={(e) => setIdempresacontadora(e.target.value)}
              />
            </Grid>

            <Grid item xs={2}>
              <label>Tipo de pago:</label>
            </Grid>
            <Grid item xs={2}>
              <FormControl className="form-control">
                <NativeSelect
                  value={tipoPago}
                  onChange={(e) => setTipoPago(e.target.value)}
                  input={<BootstrapInput />}
                >
                  <option aria-label="None" value="">
                    --Todos--
                  </option>
                  {tipoContratacion.map((tipo) => (
                    <option key={tipo.CODIGO} value={tipo.CODIGO}>
                      {tipo.NOMBRE}
                    </option>
                  ))}
                </NativeSelect>
              </FormControl>
            </Grid>
            <Grid item xs={2}>
              <label>Partner:</label>
            </Grid>
            <Grid item xs={2}>
              <FormControl className="form-control">
                <NativeSelect
                  value={esPartner}
                  onChange={(e) => setEsPartner(e.target.value)}
                  input={<BootstrapInput />}
                >
                  <option aria-label="None" value="">
                    --Todos--
                  </option>
                  {optionsPartner.map((option) => (
                    <option key={option.CODIGO} value={option.CODIGO}>
                      {option.NOMBRE}
                    </option>
                  ))}
                </NativeSelect>
              </FormControl>
            </Grid>
          </Grid>
          <Grid item xs={12} md={12}><br/></Grid>
          <Grid container spacing={1} justify="center" alignItems="center">
            <Grid item xs="auto">
              <Button
                variant="contained"
                color="primary"
                align="center"
                startIcon={<PageviewIcon />}
                onClick={() => validationInputs()}
              >
                {" "}
                Buscar
              </Button>
            </Grid>
            <Grid item xs="auto">
              <Button
                variant="outlined"
                color="primary"
                align="center"
                startIcon={<ClearAllIcon />}
                onClick={() => cleanInputs()}
              >
                {" "}
                Limpiar / Mostrar Todos
              </Button>
            </Grid>
          </Grid>
        </form>
      </div>
    </>
  );
}
